/* eslint-disable indent , no-nested-ternary */
const i18n = (...params) => window.Messages(...params);

export const template = ({ store }, storeIndex) => `

  <li class="js-store-result store-selection__store" data-store-id="${
    store.store_id
  }">

    <h4>${storeIndex + 1} - ${store.name}</h4>

    ${
      store.open.open_now /* OPEN / CLOSE + current slice */
        ? `<span class="store-selection__hours">
        ${i18n(
          'storeselection.storeOpeningHours',
          store.open.current_slice.start,
          store.open.current_slice.end
        )}
        </span>`
        : `<span class="store-selection__hours store-selection__hours--closed">
          ${i18n('storeselection.storeIsClosed')}
        </span>`
    }
    

    <div class="store-selection__cta-zone">
      CTA ?
    </div>

  </li>`;



// WEBPACK FOOTER //
// ./src/commons/component/store-finder/templates/template-simple.js